import { Injectable } from '@angular/core';
import { BrugerHistorik } from '@features/brugere/bruger-historik/bruger-historik.model';
import { RestApi } from '@core/api/rest.api';

@Injectable({
  providedIn: 'root'
})
export class BrugerHistorikApi extends RestApi<BrugerHistorik> {
  override endpoint = '/v2/brugerhistorik';

}
